/* eslint-disable react-hooks/rules-of-hooks */
import { injectable } from 'inversify';
import {
  GlobalQueryParams,
  QueryService,
} from '../../state/queryParams/queryParams.interface';
import { GlobalQueryService } from '../../state/queryParams/global.query.service';
import { RootState, useAppSelector } from '../../state/hooks';
import { createDeepEqualSelector } from '../../state/selector.helpers';
import { store } from '../../state/store';
import {
  incidentStepperQuerySelector,
  dispatchPageQuery,
} from './incidentStepper.slice';
import { IncidentStepperQuery } from './incidentStepper.interface';

// TODO: This is NOT A "page query service". remove global queryparam service
@injectable()
export class IncidentStepperService
  implements QueryService<IncidentStepperQuery & GlobalQueryParams>
{
  mergedQuerySelector!: (
    state: RootState,
  ) => IncidentStepperQuery & GlobalQueryParams;

  incidentStepperQuerySelector = incidentStepperQuerySelector;
  constructor(public globalQueryService: GlobalQueryService) {
    this.createMergeQueryParamsSelector();
  }

  useSelectMergedQuery = () => useAppSelector(this.mergedQuerySelector);

  useQuerySelector() {
    return useAppSelector(incidentStepperQuerySelector);
  }

  dispatchQueryParams = (
    queryParams: Partial<IncidentStepperQuery & GlobalQueryParams>,
  ) => {
    this.dispatchPageQuery(queryParams as Partial<IncidentStepperQuery>);

    this.globalQueryService.dispatchQueryParams(
      queryParams as Partial<GlobalQueryParams>,
    );
  };

  private createMergeQueryParamsSelector = () => {
    this.mergedQuerySelector = createDeepEqualSelector(
      incidentStepperQuerySelector,
      this.globalQueryService.globalQuerySelector,
      (
        incidentStepperQuery: IncidentStepperQuery,
        globalQuery: GlobalQueryParams,
      ) => {
        return {
          ...incidentStepperQuery,
          ...globalQuery,
        };
      },
    );
  };

  private dispatchPageQuery(queryParams: Partial<IncidentStepperQuery>) {
    const validQueryParams = this.getValidPageQueryParams(queryParams);
    const usedQueryParams = this.removeUnusedQueryParams(validQueryParams);

    store.dispatch(dispatchPageQuery(usedQueryParams));
  }

  private getValidPageQueryParams = (
    queryParams: Partial<IncidentStepperQuery>,
  ): IncidentStepperQuery => {
    return {
      activeStep: queryParams.activeStep,
    };
  };

  // removes unused properties so they don't overwrite storeParams in useQuerySync hook.
  private removeUnusedQueryParams = (
    validQueryParams: IncidentStepperQuery,
  ): Partial<IncidentStepperQuery> => {
    const usedQueryParams = {
      ...validQueryParams,
    };
    Object.keys(usedQueryParams).forEach(
      (key) =>
        usedQueryParams[key as keyof IncidentStepperQuery] === undefined &&
        delete usedQueryParams[key as keyof IncidentStepperQuery],
    );
    return usedQueryParams;
  };
}
